module.exports = __webpack_public_path__ + "img/footerball.11a9eb67.png";